var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wrapper" }, [
    _c("div", { staticClass: "menu-wrapper" }, [
      _c(
        "ul",
        _vm._l(_vm.items, function (item, index) {
          return _c(
            "li",
            {
              class: { active: _vm.activeTabSlug === item.slug },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  _vm.activeTabSlug = item.slug
                },
              },
            },
            [
              _vm._m(0, true),
              _vm._v(" "),
              _c("div", { staticClass: "label" }, [
                _c("a", {
                  attrs: { href: "" },
                  domProps: { innerHTML: _vm._s(item.name) },
                }),
              ]),
            ]
          )
        }),
        0
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "tabs-wrapper" },
      [
        _c("transition", { attrs: { name: "fade-actus-home" } }, [
          _vm.showTab("actualites")
            ? _c("div", { key: "actualites" }, [_vm._t("actualites")], 2)
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("transition", { attrs: { name: "fade-actus-home" } }, [
          _vm.showTab("agenda")
            ? _c("div", { key: "agenda" }, [_vm._t("agenda")], 2)
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("transition", { attrs: { name: "fade-actus-home" } }, [
          _vm.showTab("newsletters")
            ? _c("div", { key: "newsletters" }, [_vm._t("newsletters")], 2)
            : _vm._e(),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bar-wrap" }, [
      _c("div", { staticClass: "bar" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }